import React from 'react';

import { Form, FormItemProps, Select } from 'antd';
import { t } from 'i18next';

import { CourtType } from '../store/types';
import { courtSurfaceTypesList, courtSurfaceTypesTittle } from '../utils/const';

type Props = FormItemProps;

export const SelectCourtSurface = ({ ...formProps }: Props) => (
  <Form.Item
    label={t('table.surface-type')}
    name="surfaceType"
    {...formProps}
  >
    <Select<CourtType>>
      {courtSurfaceTypesList.map((type) => (
        <Select.Option key={type} value={type}>
          {courtSurfaceTypesTittle[type] ?? type}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
